import { Button, ButtonGroup, CircularProgress } from '@mui/material';
import CustomizedSteppers from 'components/ui/data-display/RequestStatus';
import { useTranslation } from 'react-i18next';

interface TransportActiveDocumentActionsProps {
  store: {
    ddt: any;
    isDisabledEdit: boolean;
    isGenerating: boolean;
    changesToSave: () => boolean;
    handleTmpDdt: () => Promise<void>;
    setConfirmFinalizeDialog: (open: boolean) => void;
  };
  translationPrefix: string;
}

export const TransportActiveDocumentActions = ({
  store,
  translationPrefix
}: TransportActiveDocumentActionsProps) => {
  const { t } = useTranslation();

  const hasDocument = !!store.ddt;
  const canEdit = hasDocument && !store.isDisabledEdit;
  const canFinalize = canEdit && store.ddt.status === 'NEW';
  const showActionGroup = canEdit || canFinalize;

  return (
    <div className="flex items-center justify-end">
      {/* Status Tracker */}
      <div className="w-60">
        <CustomizedSteppers status={store.ddt?.status} isActiveDDT />
      </div>

      {/* Structured Action Controls */}
      {showActionGroup && (
        <ButtonGroup size="small" variant="outlined">
          {canEdit && (
            <Button
              disabled={store.changesToSave() || store.isGenerating}
              onClick={store.handleTmpDdt}
              startIcon={
                store.isGenerating ? <CircularProgress size={16} color="inherit" /> : null
              }>
              {store.isGenerating
                ? t('global.generating', 'Generazione in corso..')
                : t(`${translationPrefix}.download-tmp`)}
            </Button>
          )}

          {canFinalize && (
            <Button
              disabled={store.changesToSave()}
              color="success"
              onClick={() => store.setConfirmFinalizeDialog(true)}>
              {t(`${translationPrefix}.finalize`)}
            </Button>
          )}
        </ButtonGroup>
      )}
    </div>
  );
};
